/*
 * @Author: zhangzhian@linshimuye.com
 * @Date: 2023-01-29 15:46:31
 * @LastEditors: Gyan
 * @LastEditTime: 2023-11-23 10:33:19
 * @FilePath: \dhr_frontend\src\utils\attachment.js
 * @Description: 文件处理方法
 * @ImportRoute: import {xxx} from '@/utils/attachment.js'
 */

import $axios from "@/utils/axios";
import Vue from "vue";
import { getOSSFileUrl } from "./oss-file";

export const wpsFileType = ["doc", "docx", "xls", "xlsx", "ppt", "pptx"];
export const imageFileType = ["jpg", "jpeg", "png"];
export const htmlFileType = ["html"];
export const pdfFileType = ["pdf"];
/**
 * 根据后缀判断文件类型
 * @returns
 */
export function judgeFileType(fileUrl, typeList) {
  const type = fileUrl.slice(fileUrl.lastIndexOf(".") + 1).toLowerCase();
  return typeList.includes(type);
}

// 获取文件名称，不带后缀
export function getFileName(fileUrl) {
  return fileUrl.slice(0, fileUrl.lastIndexOf(".")) || '--';
}

/**
 * 判断这个附件是否是存储在OSS的文件
 * @param {*} attachment
 * @returns
 */
export function judgeAliOssFile(attachment) {
  return !!attachment.aliOssLocation;
}

/**
 * 预览文件，处理各类文件，可以预览的文件都另外窗口查看，其他类型文件则触发下载
 * @param {*} fileUrl
 * @param {Function} options.otherFileHandle 对其他类型文件的处理，如果不传，则触发文件下载
 */
export async function previewCommonFile(attachment, options) {
  if (!attachment) return;

  let fileUrl = attachment.url;

  let { otherFileHandle, alertCannotPreviewFile = true } = options || {};

  const isImg = judgeFileType(attachment.suffixtt, imageFileType);
  const isWps = judgeFileType(attachment.suffixtt, wpsFileType);
  const isPdf = judgeFileType(attachment.suffixtt, pdfFileType);
  const isHtml = judgeFileType(attachment.suffixtt, htmlFileType);
  switch (true) {
    // wps类型文件打开预览页
    case isWps:
      window.open(previewWPSFile(fileUrl));
      break;
    // 图片类型文件打开预览页
    case isImg:
      window.open(fileUrl);
      break;
    // 打开预览pdf文件页
    case isPdf:
      window.open(fileUrl);
      break;
    // 打开预览pdf文件页
    case isHtml:
      window.open(fileUrl);
      break;
    // 其他文件则触发下载
    default:
      if (otherFileHandle) {
        otherFileHandle(attachment);
      } else {
        if (alertCannotPreviewFile) {
          Vue.prototype.$message.error('暂不支持该文件类型的预览');
        } else {
          downloadCommonFile(attachment)
        }
      }

      break;
  }
}

/**
 * 下载附件文件
 *
 * 参数类型一（适用于旧的本地文件服务，新的OSS文件不适用，需使用参数类型二）
 * @param {*} path // 附件
 * @param {*} downloadFileName
 *
 * 参数类型二（适用任何类型附件）
 * @param {*} attachment 附件对象
 * @param {*} downloadFileName
 * @returns
 */
export async function downloadCommonFile(path, downloadFileName) {
  let attachment = {};

  if (typeof path === "string") {
    Object.assign(attachment, {
      path,
      name: downloadFileName,
    });
  } else if (typeof path === "object") {
    attachment = { ...path };

    if (downloadFileName) {
      attachment.name = downloadFileName;
    }
  }

  switch (true) {
    case !attachment.aliOssLocation && attachment.path && attachment.path.includes(process.env.VUE_APP_OSS_FILE) :
      attachment.aliOssLocation = attachment.path.replace(process.env.VUE_APP_OSS_FILE, "")
      break;
    case !attachment.aliOssLocation && attachment.url && attachment.url.includes(process.env.VUE_APP_OSS_FILE) :
        attachment.aliOssLocation = attachment.url.replace(process.env.VUE_APP_OSS_FILE, "")
      break;
  }

  let isAliOssFile = judgeAliOssFile(attachment);

  if (isAliOssFile) {
    let fileUrl = await getOSSFileUrl(attachment);
    window.open(fileUrl, "_self");
    // window.open(fileUrl, "_blank");
  } else {
    localServerFileDownload(attachment.path, attachment.name);
  }

  Vue.prototype.$message.success("已触发下载，请稍等");
}

/**
 * 下载本地服务类型附件
 * @param {*} path 路径
 * @param {*} downloadFileName 文件名，不填用默认名，为一串id
 * @returns
 */
export function localServerFileDownload(path, downloadFileName) {
  if (path.indexOf("http") === 0) {
    path = path.split("/file/")[1];
  }

  return $axios.post(
    `/${process.env.VUE_APP_PROXY_DING_OA}/attachment/download`,
    {
      path,
    },
    {
      uselsmyAccount: true,
      type: "form",
      operate: "downloadFile",
      downloadFileName,
    }
  );
}

/**
 * 上传文件到公共服务(不建议使用，往后附件统一使用 uploadByOSS(oss-file.js文件内) 方法上传)
 * @param {*} file
 * @returns
 */
export async function uploadCommmonFile(file) {
  let { data: attachment } = await $axios.post(
    `/${process.env.VUE_APP_PROXY_DING_OA}/attachment/common/upload`,
    {
      file,
    },
    {
      type: "form",
      uselsmyAccount: true,
    }
  );

  return attachment;
}

/**
 * 预览wps文件
 * @param {*} fileUrl
 * @returns
 */
export function previewWPSFile(fileUrl) {
  if (!fileUrl) return;
  return `${window.location.protocol}//documents.linshimuye.com/op/view.aspx?src=${fileUrl}`;
}

/**
 * 预览wps文件,使用wps服务
 * @param {*} url
 * @returns
 */
export async function previewWPSFileByService(url) {
  try {
    let { data } = await $axios.get(
      `/${process.env.VUE_APP_PROXY_IT_SERVICE}/v1/api/file/getViewUrlWebPath`,

      {
        type: "json",
        uselsmyAccount: true,
        errorHandle: () => true,
        params: {
          fileUrl: url,
        },
      }
    );

    return data;
  } catch (error) {
    console.log(error);
    return "";
  }
}

/**
 * 预览pdf文件
 * @param {*} fileUrl
 * @param {*} hiddenBar 是否隐藏顶栏
 * @returns
 */
export function previewPDFFile(fileUrl, hiddenBar = true) {
  return `${fileUrl}#scrollbars=0&toolbar=0&statusbar=0`;
}

// 校验文件，包含数量、类型、大小等校验
// 返回错误信息，若为空则通过校验
export function checkFile(file, options={}) {
  if (options.limitLen && options.fileLen >= options.limitLen) {
    return `最多上传${options.limitLen}个附件`
  }

  // 大小以M为单位
  if (options.sizeLimit && (file.size / 1024) > (1024 * options.sizeLimit)) {
    return `文件大小应小于${options.sizeLimit}M`
  }

  // 文件类型应传数组
  if (options.typeLimit?.length) {
    const fileType = file.name
      .slice(file.name.lastIndexOf(".") + 1)
      .toLowerCase();

    if (!options.typeLimit.includes(fileType)) {
      return `文件类型只能为${options.typeLimit.join(",")}`
    }
  }
  return ''
}
